import { Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import AlertSvg from "../../../../SvgIcons/AlertSvg";

const InProgressWorkflowsMessage = observer(() => {
    let message =
        "In Progress Workflows must be resolved before this Evaluation can be edited.";

    return (
        <>
            <Grid
                item
                xs={12}
                sx={{
                    marginTop: "5px",
                    paddingLeft: "24px",
                    paddingRight: "24px",
                }}
                container
                direction={"column"}
                justifyContent={"flex-start"}
                alignItems="stretch"
            >
                <Grid
                    item
                    xs={12}
                    sx={{
                        border: "1px solid red",
                        borderRadius: "5px",
                        backgroundColor: "#FEEEEE",
                        paddingLeft: "5px",
                    }}
                    container
                    direction={"row"}
                    justifyContent={"flex-start"}
                    alignItems={"center"}
                    wrap={"nowrap"}
                >
                    <Grid
                        item
                        sx={{
                            marginRight: 2.7,
                            paddingTop: 1,
                            marginBottom: 0.5,
                            color: "red",
                        }}
                    >
                        <AlertSvg color="red" opacity={0.75} />
                    </Grid>
                    <Grid item>
                        <Typography
                            sx={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                letterSpacing: "0",
                                lineHeight: "20px",
                            }}
                        >
                            {message}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
});

export default InProgressWorkflowsMessage;
